import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Analytics from 'analytics-opencare';
import { updateReasonNoMatch } from 'connect/actions';
import { StepHeader, StepHeaderSubtext, StepHeaderText } from 'pages/checkout/components/common/layout-styled-components';
import { useNextCheckoutStep } from 'pages/checkout/hooks/checkoutStepHooks';
import { useCheckoutRedesignAnalyticsData } from 'pages/checkout/utils/analyticsUtils';
import { TreatmentSelector } from 'pages/funnel/components/ConcernsTreatment/TreatmentSelector';
import { selectOngoingCareNoMatch, selectReasonNoMatch } from 'pages/legacy-checkout/connect/selectors';

import { TreatmentsQuestionWrapper } from './styled-components';

const analytics = new Analytics();

export const TreatmentsQuestion = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useNextCheckoutStep();
  const analyticsData = useCheckoutRedesignAnalyticsData();

  const savedAnswerOngoingCare = useSelector(selectOngoingCareNoMatch);
  const savedTreatments = useSelector(selectReasonNoMatch) || [];

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FORM,
      pageName: 'checkout-treatments',
      name: 'checkout',
      section: 'treatments',
      ...analyticsData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- analyticsData is a new object every time, so we don't want it in the dependency array
  }, []);

  const onContinue = ({ selectedTreatments }: { selectedTreatments: string[] }) => {
    analytics.trackForm({
      pageType: analytics.pageTypes.FORM,
      pageName: 'checkout-treatments',
      name: 'checkout',
      section: 'treatments',
      content: {
        treatments: selectedTreatments.join(','),
        ...analyticsData.content,
      },
    });

    dispatch(updateReasonNoMatch(selectedTreatments));
    goToNextStep();
  };

  return (
    <TreatmentsQuestionWrapper>
      <StepHeader>
        <StepHeaderText>
          Do you have any specific concerns or treatments you require?
        </StepHeaderText>
        <StepHeaderSubtext>
          We will ensure we match you with a dentist who has expertise in these areas,
          and provide them the information
        </StepHeaderSubtext>
      </StepHeader>

      <TreatmentSelector
        savedTreatments={savedTreatments}
        isOngoingSelected={savedAnswerOngoingCare === 'Yes'}
        onContinue={onContinue}
      />
    </TreatmentsQuestionWrapper>
  );
};